<div class="container">
  <hpm-document-table [order]="order" [documentsDisabled]="documentsDisabled"></hpm-document-table>
  <hpm-upload-documents [order]="order" [documentsDisabled]="documentsDisabled"></hpm-upload-documents>
</div>
